import {END} from 'shared/constant/lookup/eventState'

/**
 * Utility function to check ticket status
 * @param {Object} ticket - The ticket data object
 * @param {boolean} ticket.is_used - Whether the ticket has been used
 * @param {string} ticket.event_date - The event date in ISO string format
 * @param {number} ticket.event_state_flag - The event state flag (0-4)
 * @returns {Object} Status object with boolean flags and reason
 */
const ticketStatusChecker = (ticket) => {
	if (!ticket) {
		return {
			isValid: false,
			isUsed: false,
			isExpired: false,
			isEventEnded: false,
			reason: '티켓 정보가 없습니다.',
		}
	}

	const {is_used, event_state_flag} = ticket

	// Check if ticket is already used
	const isUsed = Boolean(is_used)

	// Check if event has ended based on state flag
	const isEventEnded = event_state_flag === END

	// Check if event date has passed (expired)

	// Determine if ticket is valid (not used, not expired, event not ended)
	const isValid = !isUsed && !isEventEnded

	// Determine the reason for invalid status
	let reason = ''
	if (isUsed) {
		reason = '이미 사용된 티켓입니다.'
	} else if (isEventEnded) {
		reason = '종료된 이벤트의 티켓입니다.'
	} else if (isValid) {
		reason = '사용 가능한 티켓입니다.'
	}

	return {
		isValid,
		isUsed,
		isEventEnded,
		reason,
	}
}

/**
 * Quick check functions for specific conditions
 */
export const isTicketUsed = (ticket) => ticketStatusChecker(ticket).isUsed
export const isTicketEventEnded = (ticket) =>
	ticketStatusChecker(ticket).isEventEnded
export const isTicketValid = (ticket) => ticketStatusChecker(ticket).isValid
export const getTicketStatusReason = (ticket) =>
	ticketStatusChecker(ticket).reason

export default ticketStatusChecker
